class ProductInfoCollapsible extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelectorAll('[data-details]');
    this.initAccordions();
  }

  initAccordions() {
    this.details.forEach((detail) => new Accordion(detail, this.details));
  }
}

class Accordion {
  constructor(el, allDetails) {
    this.el = el;
    this.allDetails = allDetails; // Reference to all `details` elements
    this.summary = el.querySelector('[data-summary]');
    this.content = el.querySelector('[data-content]');

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = 'hidden';

    if (this.isClosing || !this.el.open) {
      this.closeOthers(); // Close other open details
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  closeOthers() {
    this.allDetails.forEach((detail) => {
      if (detail !== this.el && detail.open) {
        detail.querySelector('[data-summary]').click(); // Trigger click on the summary to close
      }
    });
  }

  shrink() {
    this.isClosing = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight],
    }, {
      duration: 250,
      easing: 'ease-out',
    });

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate({
      height: [startHeight, endHeight],
    }, {
      duration: 400,
      easing: 'ease-out',
    });

    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }
}

if (!customElements.get('product-info-collapsible')) {
  customElements.define('product-info-collapsible', ProductInfoCollapsible);
}
